import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { PaymentState } from '../../ngrx/reducers/payment.reducer';
import { UtilitiesProvider } from '../../providers/utilities';
import { ENV } from '@app/env';
import * as fromPayment from '../../ngrx/reducers/payment.reducer';
import * as paymentActions from '../../ngrx/actions/payment.actions';
import { PaymentProvider } from '../../providers/payment';
import { CouponData } from '../../providers/coupon';
import { NavController } from 'ionic-angular/navigation/nav-controller';
import moment from 'moment';
import { AnalyticsData, _ACTIONS } from '../../providers/analytics';
import { ViewController } from 'ionic-angular';
import { toArray, has } from 'lodash';

const componentName = 'PayButtonReserveComponent';

@Component({
  selector: 'app-pay-button-reserve',
  templateUrl: 'pay-button-reserve.component.html'
})

export class PayButtonReserveComponent implements OnInit, OnChanges {

  @Input() uidTrack: string;
  @Input() config: any;
  @Input() reserve: any;
  @Input() buttonLabel = null;
  @Input() calendars: number = null;
  @Input() user: any;
  @Output() onPay = new EventEmitter();

  public paymentState$: Observable<PaymentState>;
  public defaultCard;
  public buttonDisabled: boolean = true;
  public provider = ENV.payment_provider;
  public modalLoadCtrl: any;
  public clientId = ENV.client;
  public shoppingCart = {
    subtotal: 0,
    discount: 0,
    total: 0,
    coupon: null,
    apply_discount: null
  };

  constructor(
    private store: Store<any>,
    private navCtrl: NavController,
    private paymentProvider: PaymentProvider,
    private analytics: AnalyticsData,
    private couponProvider: CouponData,
    private viewCtrl: ViewController,
    private utilities: UtilitiesProvider,
  ) { }

  ngOnInit() {
    this.modalLoadCtrl = this.utilities.modal.create('ShoppingLoadModalPage', { message: 'Processing...', IsSpinner: false }, { enableBackdropDismiss: false });

    if (!this.isExternalPay) {
      this.store.dispatch(new paymentActions.GetCards());
      this.paymentState$ = this.store.select(fromPayment.getPaymentState)
        .do(state => {
          this.getDefaultCardData(state);
          if (state.error && !state.loading) {
            this.buttonDisabled = state.error.error.message;
            this.paymentProvider.registerTransactionLog('List card error pay button', state.error, this.user.info.id)
          } else {
            this.buttonDisabled = false;
          }
        });
    }

    // Se calcula el shoppingCart
    this.calculateShoppingCart();
  }

  /**
   * Visualiza metodos de pago, metodo que se usa cuando no hay TC
   * @author Juan Pablo C Mejia <jcardona@ideabti.com>
   * Revisión: 28-08-2018
   */
  public viewPaymentMethods() {
    // if (this.buttonDisabled) {
    //   this.utilities.toast.create({
    //     message: `${this.buttonDisabled}`,
    //     duration: 3000,
    //     position: 'button'
    //   }).present();
    // } else {
    this.navCtrl.push('PaymentMethodsPage');
    // }
  }

  /**
   * Explora cambios Inputs del componente
   * @param changes
   * @author Juan Pablo C Mejia <jcardona@ideabti.com>
   * Revisión: 28-08-2018
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.config) this.config = changes.config.currentValue;
    if (changes.shoppingCartPage) this.shoppingCart = changes.shoppingCartPage.currentValue;
    if (changes.buttonLabel) this.buttonLabel = changes.buttonLabel.currentValue;
    if (changes.calendars) {
      this.calendars = changes.calendars.currentValue;
      this.calculateShoppingCart();
    }
  }

  /**
   * Retorna la tarjeta de credito por defecto
   * @param paymentState
   * @author Juan Pablo C Mejia <jcardona@ideabti.com>
   * Revisión: 28-08-2018
   */
  private getDefaultCardData(paymentState: PaymentState) {
    let def = null;
    if (paymentState.default && paymentState.cards.length > 0) {
      def = paymentState.cards.find(el => el.token === paymentState.default);
      if (!def) def = null;
    } else if (!paymentState.default) {
      def = paymentState.cards[0];
    } else {
      def = null;
    }
    this.defaultCard = this.shoppingCart.total === 0 ? true : def;
  }

  /**
   * Abre modal para selecciona un nuevo metodo de pago
   * @author Juan Pablo C Mejia <jcardona@ideabti.com>
   * Revisión: 28-08-2018
   */
  public selectPayMethod() {
    const modal = this.utilities.modal.create('SelectPaymentMethodPage');
    modal.present();
    modal.onDidDismiss((data) => {
      if (data) {
        this.defaultCard = data;
      }
    });
  }

  /**
   * Emite proceso de pago
   *
   * @author Juan Pablo C Mejia <jcardona@ideabti.com>
   * Revisión: 28-08-2018
   */
  public pay() {
    let tokenCard = null;
    if (!this.isExternalPay) {
      tokenCard = has(this.defaultCard, "token") ? this.defaultCard.token : null;
    }
    return this.onPay.emit({
      tokenCard,
      shoppingCart: this.shoppingCart
    });
  }

  /**
   * Este metodo valida si se muestran las opciones de administrar los metodos de pago del usuario
   * Aplica para pago PSE, payu o cualquier pasarela que no tiene tokenizacion de tarjetas de credito
   */
  public isPaymentMethods() {
    return this.utilities.isPaymentMethods;
  }

  /**
   * Se valida si el boton de pago se habilita o no
   */
  public get isExternalPay() {
    switch (ENV.payment_provider) {
      case 'payu':
      case 'fake':
        return true;
      case 'paymentez':
      case 'payu_gateway':
        return false;
    }
  }

  public get isPayButtonEnabled() {
    if (this.isExternalPay) {
      return true;
    } else {
      if (this.defaultCard) {
        return true;
      }
    }
    return false;
  }

  public async removeCurrentCoupon() {
    if (this.shoppingCart.coupon) {
      this.utilities.alert.create({
        title: await this.utilities.translateTextOrObject('Discount code'),
        message: await this.utilities.translateTextOrObject('Do you want to delete the applied coupon?'),
        buttons: [{
          text: await this.utilities.translateTextOrObject('Cancel'),
          role: 'cancel'
        }, {
          text: await this.utilities.translateTextOrObject('Confirm'),
          handler: () => {
            this.modalLoadCtrl.present();
            this.shoppingCart.coupon = null;
            this.shoppingCart.apply_discount = null;
            this.shoppingCart.discount = 0;
            this.shoppingCart.total = this.shoppingCart.subtotal;
            this.modalLoadCtrl.dismiss()
              .then(() => this.presentToast('The discount has been delete correctly!'));
          }
        }]
      }).present();
    }
  }
  /**
   * Procesom para adicionar un codigo de descuento
   */
  public async addPromoCode() {
    this.utilities.alert.create({
      title: await this.utilities.translateTextOrObject('Discount code'),
      message: await this.utilities.translateTextOrObject('Enter your discount code'),
      inputs: [{
        type: 'text',
        value: "X68JH",
        label: await this.utilities.translateTextOrObject('Discount code'),
        name: 'code'
      }],
      buttons: [{
        text: await this.utilities.translateTextOrObject('Cancel'),
        role: 'cancel'
      }, {
        text: await this.utilities.translateTextOrObject('Ok'),
        role: 'cancel',
        handler: (data) => {
          if (data.code) {
            this.utilities.consoleDecorator('Input: ', data.code);
            this.validatePromoCodeToAdd(data.code.toUpperCase());
          } else {
            return false;
          }
        }
      }]
    }).present();
  }

  /**
   * Valida y aproba la validez del codigo
   * 1. Se valida si ya tiene un descuento aplicado
   * @param code
   */
  private async validatePromoCodeToAdd(code: string) {
    if (this.shoppingCart.apply_discount) { return this.presentAlert('Only one discount per purchase is allowed!'); }

    this.modalLoadCtrl.present();

    const coupon = await this.couponProvider.getCouponByCodeRef(code)
      .then(coupons => {
        if (coupons) {
          const key = Object.keys(coupons)[0];
          return coupons[key];
        }

        return null;
      })
      .then(cp => this.handleCouponValidationBasic(cp, code))
      .then(cp => this.handleCouponApply(cp));

    if (!coupon) {
      this.modalLoadCtrl.dismiss();
      return false;
    } else {
      this.shoppingCart.coupon = coupon;
      this.shoppingCart.apply_discount = 'coupon';
      this.calculateShoppingCart();

      return this.modalLoadCtrl.dismiss()
        .then(() => this.presentToast('The discount has been applied correctly!'))
        .then(() => this.analytics.savePageTrackOnFirestore(
          componentName,
          _ACTIONS.applyDiscountCode,
          this.uidTrack,
          { code, shoppingCart: this.shoppingCart }
        ));
    }
  }

  /**
   * La base del calculo del carrito de compra es el subtotal, esta funcion lo mantiene actualizado
   */
  private calculateShoppingCart(): boolean {
    let multiplo = 1;
    if (this.calendars > 0) {
      multiplo = this.calendars;
    }
    this.shoppingCart.subtotal = this.reserve.price * multiplo;

    if (this.shoppingCart.apply_discount === 'coupon' && this.shoppingCart.coupon) {
      this.shoppingCart.discount = this.shoppingCart.subtotal * (this.shoppingCart.coupon.objects_value / 100);
    } else {
      this.shoppingCart.discount = 0;
    }

    this.shoppingCart.total = this.shoppingCart.subtotal - this.shoppingCart.discount;

    return true;
  }

  /**
   * Se hace validacion avanzada
   * 1. se valida que el cupon haya pasado las validaciones basicas
   * @param coupon
   * @param code
   */
  private handleCouponApply(evalCoupon: any) {
    let flagCoupon = false;
    if (evalCoupon) {
      Object.keys(evalCoupon.objects).map(keyCoupon => {
        if (this.reserve.id === evalCoupon.objects[keyCoupon].id) {
          flagCoupon = true;
        }
      });
      if (!flagCoupon) {
        this.utilities.consoleDecorator('12', evalCoupon);
        this.presentAlert('The entered code is invalid!');
      }

      return flagCoupon ? evalCoupon : false;
    } else {
      return false;
    }
  }

  /**
   * Validacion basica del coupon
   * @param evalCoupon
   * @param code
   */
  private handleCouponValidationBasic(evalCoupon: any, code: string) {
    if (evalCoupon) {
      if (!evalCoupon.state) {
        this.utilities.consoleDecorator('1', evalCoupon);
        this.presentAlert('The entered code is invalid!');
        return false;
      }

      if (evalCoupon.type_discount !== 'reserve') {
        this.utilities.consoleDecorator('2', evalCoupon);
        this.presentAlert('The entered code is invalid!');
        return false;
      }

      if (evalCoupon.expiration_date < moment().format()) {
        this.utilities.consoleDecorator('3', evalCoupon);
        this.presentAlert('The code entered is expired!');
        return false;
      }

      if (evalCoupon.objects_type_pay !== 'app') {
        this.utilities.consoleDecorator('4', evalCoupon);
        this.presentAlert('The coupon can only be used for physical payment, please go to an authorized discount point!');
        return false;
      }

      if (evalCoupon.privacy === 'private') {
        if (!this.user.info.profile) {
          this.utilities.consoleDecorator('5', evalCoupon);
          this.presentAlert('The entered code is invalid!');
          return false;
        }

        if (!evalCoupon.profiles_view[this.user.info.profile]) {
          this.utilities.consoleDecorator('6', evalCoupon);
          this.presentAlert('The entered code is invalid!');
          return false;
        }
      }

      if (evalCoupon.type_coupon === 'code') {
        if (evalCoupon.quota >= evalCoupon.used_quota) {
          this.utilities.consoleDecorator('7', evalCoupon);
          this.presentAlert('The coupon entered is no longer available!');
          return false;
        }
        return this.couponProvider.getCouponUserByIdRef(evalCoupon.id, this.user.info.id)
          .then(couponUser => {
            if (couponUser) {
              if (couponUser.redeemed) {
                this.utilities.consoleDecorator('7.1', evalCoupon);
                this.presentAlert('The coupon entered has already been redeemed!');
                return false;
              }
            }
            return evalCoupon;
          });
      } else if (evalCoupon.type_coupon === 'coupon') {
        return this.couponProvider.getCouponUserByCodeRef(code, this.user.info.id)
          .then(couponsUser => {
            couponsUser = toArray(couponsUser);
            if (couponsUser.length > 0) {
              const evalCouponUser = couponsUser[0];
              if (evalCouponUser.redeemed) {
                this.utilities.consoleDecorator('8', evalCoupon);
                this.presentAlert('The coupon entered has already been redeemed!');
                return false;
              } else {
                return evalCoupon;
              }
            } else {
              this.utilities.consoleDecorator('9', evalCoupon);
              this.presentAlert('The entered code is invalid!');
              return false;
            }
          })
      } else {
        this.utilities.consoleDecorator('10', evalCoupon);
        this.presentAlert('An error has occurred when trying to enter the coupon');
        return false;
      }
    } else {
      this.utilities.consoleDecorator('11', evalCoupon);
      this.presentAlert('The entered code has not been found!');
      return false;
    }
  }


  /**
   * Presenta mensaje tipo Alert
   * @param message
   * @param title
   */
  private async presentAlert(message: string, title: string = 'Alert') {
    return this.utilities.alert.create({
      title: await this.utilities.translateTextOrObject(title),
      message: await this.utilities.translateTextOrObject(message),
      buttons: [{
        text: 'Ok',
        role: 'cancel'
      }]
    }).present();
  }


  /**
   * Create and present a toast with custom message and default values
   * @param message toast message
   * @param duration toast duration in milliseconds
   * @param position toast position
   * @author Jhonny Martínez
   */
  private async presentToast(msg: string, duration = 5000, position = 'top') {
    let message = await this.utilities.translateTextOrObject(msg)
    this.utilities.toast.create({ message, duration, position }).present();
  }
}



// WEBPACK FOOTER //
// ./src/components/pay-button-reserve/pay-button-reserve.component.ts